import React from 'react'
import { createImageIconComponent } from './library'

export const IconAnnouncementCall = createImageIconComponent(
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23.5 22"
    style={{ height: '1.2em', marginLeft: '-2px', marginRight: '-2px' }}
  >
    <g id="g4558">
      <path
        className="st0"
        d="M16,8c0-0.6-0.3-1.2-0.8-1.4v-4c0-0.2-0.2-0.8-0.8-0.8c-0.2,0-0.4,0.1-0.5,0.2l-2.2,1.8C10.5,4.5,9.1,5,7.6,5
		h-5C1.7,5,0.9,5.8,0.9,6.7v2.5c0,0.9,0.8,1.7,1.7,1.7h0.9c0,0.3-0.1,0.6-0.1,0.8c0,1,0.2,2,0.7,2.9c0.1,0.3,0.4,0.4,0.7,0.4h1.9
		c0.7,0,1.1-0.8,0.7-1.3c-0.4-0.6-0.7-1.3-0.7-2c0-0.3,0-0.6,0.1-0.8h0.7c1.4,0,2.8,0.5,4,1.4l2.2,1.8c0.1,0.1,0.3,0.2,0.5,0.2
		c0.7,0,0.8-0.6,0.8-0.8v-4C15.7,9.1,16,8.6,16,8z M13.5,11.7L12.6,11c-1.4-1.1-3.2-1.8-5-1.8V6.7c1.8,0,3.6-0.6,5-1.8l0.9-0.7V11.7
		z"
        fill="currentColor"
      />
    </g>
    <g id="g4554" transform="translate(7.9719248,4.7947073)">
      <path
        className="st0"
        d="M14.2,0.3L11-0.4c-0.3-0.1-0.7,0.1-0.8,0.4L8.7,3.4c-0.1,0.3,0,0.7,0.2,0.9l1.9,1.5c-1.1,2.4-3,4.3-5.5,5.5
		L3.8,9.4C3.6,9.2,3.2,9.1,2.9,9.2l-3.4,1.5c-0.3,0.1-0.5,0.5-0.4,0.8l0.7,3.2c0.1,0.3,0.4,0.6,0.7,0.6c7.9,0,14.3-6.4,14.3-14.3
		C14.8,0.7,14.6,0.4,14.2,0.3z"
        fill="currentColor"
      />
    </g>
  </svg>
)
